import React, { useContext } from 'react';
import ReactHTMLParser from 'react-html-parser';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import { SecondaryHero } from '@latitude/hero';
import { Heading2 } from '@latitude/heading';
import { 
  ALIGN, 
  COLOR,
  MARGIN,
  BREAKPOINT
} from '@latitude/core/utils/constants';
import { Heading4 } from '@/components/Heading/Heading';
import Image from '@latitude/image';
import { StickyNavigation } from '@latitude/sticky-navigation';
import Layout from '../components/layout';
import Section from '../components/Section/Section';
import PageData from '../data/pages/adverse-publicity-notice/index.json';
import { PageContext } from '@/context/PageContext';
import Text from '../components/Text/Text';
import '../../sass/_table.scss';
import logosHeader from '../images/lfs-hn-logos-688x48.webp';

const AdversePublicityNotice = ({ location, data }) => {
    /** Contentful Data */
    const contentfulPageData = useContext(PageContext);
    const state = contentfulPageData?.updatedBody || {};
    /** - END - */
    return (
        <Layout location={location}>
            <main className="navigation-spacer">
                <Helmet>
                    <title>{PageData.metaTitle} </title>
                    <meta name="description" content={PageData.metaDesc} />
                    <link
                        href="https://www.latitudefinancial.com.au/adverse-publicity-notice/"
                        rel="canonical"
                    />
                </Helmet>

                <div className="d-none d-lg-block">
                    <StickyNavigation
                        items={PageData.nav}
                        offsetElem="[data-sticky-navigation-offset]"
                        {...state?.inPageNavData?.[0]}
                    />
                </div>         

                <Section id="statement">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                          <Heading4 
                            class="centered-text"
                            css={`
                              padding-bottom: 15px;
                              font-family: "Latitude Sans";
                              font-size: 1.125rem;
                              font-weight: 600;
                            `}
                            color={COLOR.BLACK}
                            marginBottom={MARGIN.M16}
                            isResponsive={false}
                          >
                            <center>
                                ADVERSE PUBLICITY NOTICE PUBLISHED BY ORDER OF THE FEDERAL COURT OF AUSTRALIA
                            </center>
                          </Heading4>
                          <Image
                            class="h-md-75 h-100"
                            css={`
                                max-width: 80%;

                                @media (min-width: ${BREAKPOINT.MD}) {
                                  max-width: 100%;
                                }
                                `}
                            src={logosHeader}
                            alt="latitude-and-harvery-norman-logo"
                            imageOnly
                          />   
                        </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8 offset-lg-2">
                        <Text
                            css={`
                              padding-bottom: 15px;
                              font-family: "Latitude Sans";
                              font-size: 1rem;
                            `}
                        >
                            <p
                            css={`
                              font-size: 1.125rem;
                              font-weight: 600;
                            `}
                            ><center><strong>Misleading Representations and Conduct Liable to Mislead the Public by Latitude and Harvey Norman during 1 January 2020 to 11 August 2021</strong></center></p>
                            <p>Following successful action by the Australian Securities and Investments Commission (ASIC), on 18 October 2024, the Federal Court of Australia found that Latitude Finance Australia (Latitude) and Harvey Norman Holdings Limited (Harvey Norman) made misleading representations, engaged in misleading conduct and engaged in conduct liable to mislead the public in their 1 January 2020 to 11 August 2021 national television, radio and newspaper advertising campaign promoting a no deposit and 60 months interest free payment method for buying goods at Harvey Norman, Domayne and Joyce Mayne stores. Latitude and Harvey Norman were each ordered by the Federal Court on 28 July 2026 to pay penalties of $20 million and of $35 million, respectively, to the Commonwealth in respect of this conduct.</p>
                            <p>Latitude and Harvey Norman failed to disclose in those advertisements that:</p>
                            <p>(a) an essential precondition for acquiring goods pursuant to the advertised payment method was that the consumer has or enters into a continuing credit contract linked to a credit card; and</p>
                            <p>(b) a consumer taking up the advertised payment method would, in addition to the purchase price, be required to pay a $25 establishment fee (during the period 1 January 2020 to 15 March 2021) and ongoing monthly account service fees, which since 1 January 2020 have increased from $5.95 per month to $10.95 per month. </p>
                            <p>The Federal Court has also ordered Latitude and Harvey Norman to pay ASIC’s costs of the litigation and issue this adverse publicity notice. </p>
                            <p
                            css={`
                              word-break: break-word;
                            `}>The 18 October 2024 judgment can be found on the Federal Court’s website at <a href='https://www.judgments.fedcourt.gov.au/judgments/Judgments/fca/single/2024/2024fca1205' target='_blank'>https://www.judgments.fedcourt.gov.au/judgments/Judgments/fca/single/2024/2024fca1205</a>, the 28 July 2026 judgment can be found on the Federal Court’s website at <a href='https://www.judgments.fedcourt.gov.au/judgments/Judgments/fca/single/2026/2026fca0989' target='_blank'>https://www.judgments.fedcourt.gov.au/judgments/Judgments/fca/single/2026/2026fca0989</a> and ASIC’s media release is at <a href='https://www.asic.gov.au/about-asic/news-centre/find-a-media-release/2026-releases/26-171mr-harvey-norman-and-latitude-ordered-to-pay-combined-55-million-penalties-for-misleading-customers/' target='_blank'>https://www.asic.gov.au/about-asic/news-centre/find-a-media-release/2026-releases/26-171mr-harvey-norman-and-latitude-ordered-to-pay-combined-55-million-penalties-for-misleading-customers/</a>.</p>
                            
                            <p 
                            css={`
                              font-size: 1.125rem;
                              font-weight: 600;
                            `}><center><strong class="centered-text">Latitude Apology</strong></center></p>
                            <p>Latitude acknowledges and accepts responsibility for what occurred and apologises unreservedly to our customers for engaging in the conduct that led to these contraventions. </p>
                        </Text>
                      </div>
                    </div>                    
                </Section>
            </main>
        </Layout>
    );
};

export default AdversePublicityNotice;